export const pageSizeOptions = [10, 20, 50, 100];
